import React from "react";
import { Wifi, Wine, Utensils, Tv, Star } from "lucide-react";

const amenityIcons = {
  "WiFi": Wifi,
  "Bar": Wine,
  "Catering": Utensils,
  "Entertainment": Tv,
};

export function JetAmenities({ amenities }) {
  if (!amenities || amenities.length === 0) return null;

  return (
    <div className="glass p-6">
      <h3 className="label-text text-[#D4AF37] mb-4">Amenities</h3>
      <div className="flex flex-wrap gap-3">
        {amenities.map((amenity) => {
          const Icon = amenityIcons[amenity] || Star;
          return (
            <div key={amenity} className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10">
              <Icon className="w-4 h-4 text-[#D4AF37]" />
              <span className="text-sm">{amenity}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function JetDescription({ description }) {
  if (!description) return null;

  return (
    <div className="glass p-6">
      <h3 className="label-text text-[#D4AF37] mb-4">About This Flight</h3>
      <p className="text-white/70 leading-relaxed">{description}</p>
    </div>
  );
}
